<template>
  <div class="scan-page"  v-loading="loading"
       element-loading-text="正在加载，请稍等..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)" >
    <!-- Element卡片容器 -->
    <!--未锁定状态-->
    <el-card class="box-card" shadow="hover" v-if="!lockState">
      <div slot="header" class="card-header">
        <i class="el-icon-s-data" style="color: #caff00" ></i>
        <span style="color:#fff;margin-left: 5px">设备实时数据监测</span>
      </div>
      <!-- 参数展示表单 -->
<!--      <div style="height: 37px;margin-bottom: 15px;border-bottom: solid 1px #f3ebeb">
        <el-divider direction="vertical"></el-divider>
        <span>基本信息</span>
      </div>-->
      <el-divider content-position="center">基本信息</el-divider>
      <el-form :model="paramForm" label-width="120px" size="medium" label-position="left" class="basicForm">
        <el-form-item>
          <template slot="label">
            <i class="el-icon-s-order"></i>
            <span>设备名称</span>
          </template>
          <span @click="handleUpdate" v-if="queryForm.meterName">{{queryForm.meterName}}</span>
          <span @click="handleUpdate" v-else style="color:red;">【 请配置站点名称 】</span>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <i class="el-icon-s-open"></i>
            <span>设备编码</span>
          </template>
          <span>{{queryForm.deviceCode}}</span>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <i class="el-icon-phone"></i>
            <span>SIM卡号</span>
          </template>
          <span>{{queryForm.iccid}}</span>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <i class="el-icon-s-flag"></i>
            <span>SIM卡状态</span>
          </template>
          <el-tag type="primary" v-if="!isEmptyParams" size="medium" effect="dark"><i class="el-icon-check" style="padding-right: 3px"></i>正常</el-tag>
        </el-form-item>
      </el-form>

      <!-- 业务操作按钮 -->
      <el-divider content-position="center" class="divider">实时数据</el-divider>
      <el-form :model="paramForm" label-width="130px" size="medium" label-position="left" class="secondForm">
        <el-form-item>
          <template slot="label">
            <i class="el-icon-alarm-clock"></i>
            <span>最新上报</span>
          </template>
          <span class="value" v-if="queryForm.netWorkTime==null" style="color: red">未上线</span>
          <span class="value" v-else>{{queryForm.netWorkTime }}</span>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <i class="el-icon-info"></i>
            <span  @dblclick="handleDoubleClick">设备状态</span>
          </template>
          <span>
            <el-tag type="success" v-if="queryForm.netState=='1'" size="medium" effect="dark"><i class="el-icon-circle-check" style="padding-right: 3px"></i>在线</el-tag>
            <el-tag type="danger" v-if="queryForm.netState=='0'" size="medium" effect="dark"><i class="el-icon-circle-close" style="padding-right: 3px"></i>离线</el-tag>
          </span>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <i class="el-icon-s-operation"></i>
            <span>瞬时流量</span>
          </template>
          <span v-if="queryForm.instantRatio=='2' || queryForm.rsrp!='Y'">{{ queryForm.instantFlow==null?0:queryForm.instantFlow }}</span>
          <span v-if="queryForm.instantRatio=='2' || queryForm.rsrp!='Y'" style="margin-left: 3px">m³/h</span>
          <span v-else style="color:red">无【485】通讯信号</span>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <i class="el-icon-s-marketing"></i>
            <span>正向累计流量</span>
          </template>
          <span class="value" >{{queryForm.positiveCumulativeFlow==null?0:queryForm.positiveCumulativeFlow }}</span>
          <span style="align-content:flex-end;margin-left: 3px">m³</span>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <i class="el-icon-s-marketing"></i>
            <span>反向累计流量</span>
          </template>
          <span class="value" >{{queryForm.reverseCumulativeFlow==null?0:queryForm.reverseCumulativeFlow }}</span>
          <span style="align-content:flex-end;margin-left: 3px">m³</span>
        </el-form-item>
      </el-form>
      <!-- 业务操作按钮 -->
      <el-divider content-position="center" class="divider">功能导航</el-divider>
      <el-row style="margin-top: 25px">
        <el-col :span="8" style="border-right: solid 2px #d7d7d7">
          <div class="grid-content bg-purple" @click="returnHomePage">
            <i class="el-icon-s-home"></i><br>
            <span>回到列表页</span>
            <!--            <el-button type="primary" icon="el-icon-refresh" @click="refreshParams" size="small" style="margin-left: 10px;">即刻刷新</el-button>-->
          </div>
        </el-col>
        <el-col :span="8" style="border-right: solid 2px #d7d7d7">
          <div class="grid-content bg-purple" @click="refreshParams">
            <i class="el-icon-refresh"></i><br>
            <span>即刻刷新</span>
<!--            <el-button type="primary" icon="el-icon-refresh" @click="refreshParams" size="small" style="margin-left: 10px;">即刻刷新</el-button>-->
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light" @click="jumpToDetail">
            <i class="el-icon-s-order"></i><br>
            <span>历史数据</span>
<!--            <el-button type="success" icon="el-icon-view" @click="jumpToDetail" size="small" style="margin-left: 55px;">查看历史数据</el-button>-->
          </div>
        </el-col>
      </el-row>
      <el-row style="margin:25px 0 10px 0"></el-row>
    </el-card>
    <!--锁定状态-->
    <el-card class="box-card" shadow="hover" v-if="lockState">
<!--      <div slot="header" class="card-header">
        <i class="el-icon-s-data" style="color: #caff00" ></i>
        <span style="color:#fff;margin-left: 5px">设备实时数据监测</span>
      </div>-->
      <div>
        <el-result icon="warning" title="温馨提示" :subTitle="lockTxt">
          <template slot="extra" style="margin-top: 20px!important;font-weight: bold;">
            <el-link :underline="false" icon="el-icon-phone-outline" type="primary">Tel: </el-link>
            <el-link :underline="false" type="primary"><a href="tel:15025874151"></a>15025874151</el-link>
          </template>
        </el-result>

      </div>
    </el-card>
    <HeaderLogo v-if="!lockState"></HeaderLogo>
    <!-- 空参数提示 -->
<!--    <el-empty v-if="isEmptyParams" description="未解析到扫码参数，请扫描有效二维码" style="margin-top: 50px;">
      <el-button type="primary" @click="refreshParams">重新解析</el-button>
    </el-empty>-->

<!--    验证手机号dialog-->
    <el-dialog title="验证手机号" :visible.sync="dialogVisible" width="80%" top="50%" class="telDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="validateForm" ref="validateForm" label-position="left" label-width="75px" class="demo-ruleForm" size="mini">
        <el-row>
          <span style="padding-left: 9px;color: red">备注：验证手机号后才能查看设备列表</span>
        </el-row>
        <el-row style="padding: 15px 0 18px 0">
          <el-form-item label="手机号" prop="tel" :rules="[{ required: true, message: '手机号不能为空'},{ type: 'number', message: '手机号必须为数字'},{pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号',trigger: 'blur'}]">
            <el-input v-model.number="validateForm.tel" placeholder="输入手机号"  autocomplete="off" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item>
            <el-button type="primary" :loading="btnLoading" @click="submitForm('validateForm')">提 交 验 证</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
    <!--    修改站点名称dialog-->
    <el-dialog title="修改站点名称" :visible.sync="siteVisible" width="80%" top="50%" class="siteDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="siteInfoForm" ref="siteInfoForm" label-position="left" label-width="80px" class="demo-ruleForm" size="mini">
        <el-row style="padding-top:10px">
          <el-form-item label="站点编码" prop="tel">
            <el-input v-model.number="siteInfoForm.deviceCode" disabled autocomplete="off" ></el-input>
          </el-form-item>
        </el-row>
        <el-row style="padding: 0px 0 18px 0">
          <el-form-item label="站点名称" prop="tel">
            <el-input v-model.number="siteInfoForm.meterName" placeholder="站点名称"  clearable autocomplete="off" ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item>
            <el-button type="primary" :loading="btnLoading" @click="submitUpdateForm('siteInfoForm')">提 交 修 改</el-button>
            <el-button @click="siteVisible = false">取 消</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
      </div>
</template>

<script>
import HeaderLogo from '@/components/HeaderLogo.vue'
export default {
  name: 'ScanPage',
  components: {
    HeaderLogo
  },
  props: {
    deviceCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lockState: false,
      lockTxt: '设备已锁定，请联系厂家或技术人员',
      btnLoading:false,
      siteInfoForm:{
        meterName: '',
        deviceCode: ''
      },
      siteVisible:false,
      validateForm: {tel: ''},
      dialogVisible: false,
      title: '额济纳旗生活1号井',
      paramForm: {
        deviceCode: ''
      },
      queryForm:{},
      loading: false,
      isEmptyParams: false
    }
  },
  created() {
    this.loading = true;
    // 初始化解析参数
    //this.parseUrlParams()
    // 可选：初始化微信JS-SDK（如需调用微信API）
    // this.initWxJsSdk()
  },
  watch: {
    // 监听路由参数变化
    '$route.query': {
      handler() {
        this.parseUrlParams()
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 解析URL参数（核心）
     */
    parseUrlParams() {
      this.loading = true;
      try {
        // 方式1：通过路由props解析（推荐）
        this.paramForm = {deviceCode: decodeURIComponent(this.deviceCode || '')}
        // 判断是否为空参数
        if(this.paramForm.deviceCode){
          //查询动态数据--先判断该编号是否锁定
         this.getQueryList();
        }
      } catch (e) {
        this.$message.error(`参数解析失败：${e.message}`)
      }
    },
    handleUpdate(){
      let tel = localStorage.getItem("scanTel");
      if(tel=="15109360147" || tel=="15025874151"){
        this.siteVisible = true;
      }
    },
    handleDoubleClick(){
      localStorage.clear();
      this.$message({
        message: '缓存已清除. . . . . .',
        type: 'warning',
        center: true,
        offset:50
      });
    },
    /**
     * 查询动态数据
     * 公共方法
     */
    getQueryList(){
      //this.paramForm = {deviceCode:"867920071452347"};
      this.$http.post(process.env.VUE_APP_API_BASE_URL+'deviceInfo/device_info/scan_query', this.paramForm)
          .then(res => {
            if (res.code === 200 && res.hasOwnProperty("data")) {
              this.isEmptyParams = false;
              if (res.data.lockState=="3"){//锁定
                this.lockState = true;
              }else{//未锁定
                this.lockState = false;
                this.queryForm = res.data;
                this.siteInfoForm = res.data;
                this.paramForm.deviceCode = res.data.deviceCode;
                this.$message({
                  message: '恭喜哦，数据加载成功. . . . . .',
                  type: 'success',
                  center: true,
                  offset:50
                });
              }
            } else {
              this.isEmptyParams = true;
              this.$message({
                message: '抱歉哦，数据加载失败. . . . . .',
                type: 'warning',
                center: true,
                offset:50
              });
            }
          })
          .finally(() => {
            this.loading = false
          })
    },
    /**
     * 提交电话号码
     * @param formName
     */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.$http.post(process.env.VUE_APP_API_BASE_URL+'deviceInfo/device_info/scan_query_list', this.validateForm)
              .then(res => {
                if (res.code === 200 && res.hasOwnProperty("data")) {
                  //跳转ScanDeviceList页面
                  if(res.data.length>0){
                    // 将数据存入 localStorage
                    localStorage.setItem('scanTel', this.validateForm.tel);
                    this.$router.push({path: '/deviceList', query: {tel: this.validateForm.tel}});
                  }else{
                    this.$message({
                      message: '抱歉哦，您暂无获取列表的权限，请联系技术人员...',
                      type: 'warning',
                      center: true,
                      offset:50
                    });
                  }
                } else {
                  this.$message({
                    message: '抱歉哦，数据加载失败. . . . . .',
                    type: 'warning',
                    center: true,
                    offset:50
                  });
                }
              })
              .finally(() => {
                this.btnLoading = false
              })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 提交修改--设备名称
     * @param formName
     */
    submitUpdateForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.$http.put(process.env.VUE_APP_API_BASE_URL+'deviceInfo/device_info/scan_query_update', this.siteInfoForm)
            .then(res => {
              if (res.code === 200) {
                //跳转ScanDeviceList页面
                  this.$message({
                    message: '恭喜哦，提交修改成功. . . . . .',
                    type: 'success',
                    center: true,
                    offset:50
                  });
                this.siteVisible = false;
              } else {
                this.$message({
                  message: '抱歉哦，提交修改失败. . . . . .',
                  type: 'warning',
                  center: true,
                  offset:50
                });
              }
            })
            .finally(() => {
              this.btnLoading = false
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 返回主页
     */
    returnHomePage(){
      let tel = localStorage.getItem("scanTel");
      if(tel!=null && tel!=""){
        this.$router.push({path: '/deviceList', query: {tel: tel}});
      }else{
        this.dialogVisible = true;
      }
    },
    /**
     * 跳转到详情页（带参数）
     */
    jumpToDetail() {
      // 方式1：query传参（推荐，URL可见，支持刷新）
      if(!this.isEmptyParams){
        this.$router.push({
          path: '/history',
          query: {deviceCode: this.paramForm.deviceCode}
        });
      }else{
        this.$message({
          message: '抱歉哦，数据加载失败. . . . . .',
          type: 'warning',
          center: true
        });
      }
    },
    /**
     * 原生URL参数解析（备用）
     */
    getNativeUrlParams() {
      const params = {}
      const search = window.location.search.substring(1)
      if (search) {
        search.split('&').forEach(item => {
          const [key, value] = item.split('=')
          if (key) {
            params[decodeURIComponent(key)] = decodeURIComponent(value || '')
          }
        })
      }
      return params
    },

    /**
     * 业务提交（替换为你的实际接口）
     */
    handleSubmit() {
      if (this.isEmptyParams) {
        this.$message.warning('请先扫描有效二维码！')
        return
      }

      this.loading = true
      // 模拟后端接口请求（替换为你的实际接口地址）
      this.$http.post('/api/submit-scan-param', this.paramForm)
          .then(res => {
            if (res.code === 200) {
              this.$message.success(`提交成功！\n用户ID：${this.paramForm.userId}`)
            } else {
              this.$message.error(res.msg || '提交失败')
            }
          })
          .finally(() => {
            this.loading = false
          })
    },

    /**
     * 刷新参数
     */
    refreshParams() {
      this.loading = true;
      this.parseUrlParams()
      //this.$message.info('参数已刷新！')
    },


    /**
     * 初始化微信JS-SDK（可选，如需调用微信分享/支付等）
     */
    initWxJsSdk() {
      // 1. 后端获取签名（替换为你的签名接口）
      this.$http.get('/api/wx/get-jsapi-signature', {
        params: { url: window.location.href.split('#')[0] }
      }).then(res => {
        if (res.code === 200) {
          const { appId, timestamp, nonceStr, signature } = res.data
          // 2. 配置微信JS-SDK
          wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'] // 按需添加
          })
          // 3. 微信SDK就绪
          wx.ready(() => {
            console.log('微信JS-SDK初始化成功')
            // 示例：配置分享
            wx.onMenuShareAppMessage({
              title: '豪创信息技术-扫码页面',
              desc: `用户ID：${this.paramForm.userId}`,
              link: window.location.href,
              imgUrl: `${window.location.origin}/static/logo.png` // 替换为你的logo地址
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-card__body{
  overflow: auto;
  height: 650px;
}
.scan-page {
  /*padding: 10px 20px;*/
  max-width: 750px;
  margin: 0 auto;
  background-color: #f5f5f5;
  min-height: 100vh;
/*  overscroll-behavior: none; !* 禁止下拉/上拉滚动行为 *!
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;*/
}

.box-card {
  background: #fff;
  border-radius: 8px;
}

::v-deep .box-card .el-result__extra{
  font-size: 25px;
  margin-top: 15px!important;
}
::v-deep .box-card .el-result__extra .el-link--inner{
  font-size: 25px;
  margin-top: 15px!important;
  font-weight: bold;
}
::v-deep .box-card .el-result__extra .el-icon-phone-outline{
  font-size: 25px;
  margin-top: 13px!important;
}
::v-deep .el-result{
  padding: 30% 30px!important;
}
::v-deep .el-result .el-result__subtitle p{
  color: red;
  font-weight: 600;

}


.card-header {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  position: relative;
}

.card-header span {
  margin-left: 3px;
  font-size: 15px;
}

.header-icon {
  font-size: 18px;
  margin-right: 8px;
  color: #1989fa;
}

.header-image{
  position: absolute;
  width: 210px;
  height: 30px;
  right: 0;
  padding-top: 9px
}

/* Element样式穿透适配 */
::v-deep .el-card__header {
  padding: 0;
  height: 55px;
  line-height: 55px;
 /* border-bottom: 1px solid #f0f0f0;*/
  background: #409eff;
}

::v-deep .el-form-item {
  margin-bottom: 20px;
}

::v-deep .el-input__inner {
  font-size: 14px;
  padding: 10px;
}

::v-deep .el-divider__text {
  font-size: 14px;
  color: #666;
}
::v-deep  .el-form-item__label{
  font-size: 16px;
}
::v-deep  .el-form-item__label i{
  font-size: 17px;
  color: #5ba338;
}
::v-deep .basicForm .el-form-item{
  border-bottom: solid 1px #f3ebeb;
}
::v-deep .secondForm .el-form-item{
  border-bottom: solid 1px #f3ebeb;
}
::v-deep .el-form-item__content{
  text-align: right;
  font-weight: 600;
  font-size: 16px;
}

::v-deep .telDialog .el-dialog__body{
  padding-bottom: 0;
  padding-top: 15px;
}
::v-deep .telDialog .el-button{
  padding: 8px 20px;
}
::v-deep .siteDialog .el-dialog__body{
  padding-bottom: 0;
  padding-top: 15px;
}
::v-deep .siteDialog .el-button{
  padding: 8px 20px;
}
::v-deep .siteDialog .el-form-item__label{
font-size: 15px;
}

::v-deep .el-form-item__label span{
  margin-left: 3px;
}
::v-deep .el-divider--vertical{
  width: 3px;
  background-color: #609ffd;
}
::v-deep .el-divider--horizontal{
  margin: 10px 0 18px 0
}
::v-deep .el-divider__text{
  color: #3cb2f9;
  font-size: 16px;
  font-weight: 600;
}
::v-deep .divider{
  margin-top: 35px;
}
::v-deep .grid-content{
  text-align: center;
  font-size: 15px;
}
::v-deep .grid-content .el-icon-refresh{
  color:orange;
  font-size: 20px;
}
::v-deep .grid-content .el-icon-view{
  color: #57cf0f;
  font-size: 20px;
}
.el-row .el-col{
  height: 55px;
  line-height:20px;
  box-shadow: #d7cfcf 0px 0px 10px;
  padding:5px;
}
.el-row .el-col:hover{
  background-color: #ccc;
}
.grid-content .el-icon-s-home{
  font-size: 20px;
  color: #d12d4c;
}
.grid-content .el-icon-s-order{
  font-size: 20px;
  color: #0093db;
}
</style>